import { render, staticRenderFns } from "./ReporteORI.vue?vue&type=template&id=1269b40b&scoped=true"
import script from "./ReporteORI.vue?vue&type=script&lang=js"
export * from "./ReporteORI.vue?vue&type=script&lang=js"
import style0 from "./ReporteORI.vue?vue&type=style&index=0&id=1269b40b&prod&scoped=true&lang=css"
import style1 from "../main.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1269b40b",
  null
  
)

export default component.exports